import { createSelector } from 'reselect';
import { ICEXExchange } from '@kattana-io/common';
import { IStore } from '../reducers';
import { ECEXExchangeName } from '../reducers/cex_trading';

type ExchangeInfo = {
  activeExchange?: ICEXExchange;
  exchange: ECEXExchangeName;
};

const getExchangeInfo = createSelector(
  (state: IStore) => state.cex_trading.currentExchange,
  (state: IStore) => state.cex_trading.exchanges,
  (currentExchange, exchanges): ExchangeInfo => ({
    activeExchange: exchanges[currentExchange],
    exchange: currentExchange,
  })
);

export { getExchangeInfo };
